import React from 'react'
import clsx from 'clsx'

// The emerald->teal gradient heading from the Home hero. `as` picks the tag
// (h1 for page titles, h2 for section titles); pass sizing via className.
export function BrandHeading({ as: Tag = 'h1', className = '', children }) {
  return (
    <Tag
      className={clsx(
        'bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text font-bold tracking-tight text-transparent dark:from-emerald-400 dark:to-teal-400',
        className,
      )}
    >
      {children}
    </Tag>
  )
}

export default BrandHeading
